export const SET_HAS_PERSONAL_DATA = 'SET_HAS_PERSONAL_DATA';

export const SetHasPersonalData = (value) => {
    return {
        type: SET_HAS_PERSONAL_DATA,
        payload: {
            value: value
        }
    }
}